// @flow
import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, SubmissionError } from 'redux-form'
import formatters from 'lib/formatters'
import cleaners from 'lib/form/cleaners'
import { httpGet, httpPut } from 'lib/http'
import { setBanner, setLoad, setUnload } from 'lib/notification/actions'
import Component from './component'
import { withRouter } from 'lib/hooks/withRouter'

type Props = {
  dispatch: Function,
  params: Object,
  location: Object,
}

const ComponentForm = reduxForm({
  form: 'editContact',
  propNamespace: 'form',
})(Component)

class Container extends React.Component<Props> {
  constructor(props) {
    super(props)

    this.state = {
      contact: null,
      errors: {},
    }
  }

  componentDidMount() {
    const { dispatch, location } = this.props
    const params = location?.params
    dispatch(setLoad())
    httpGet(`/admin/contacts/${params.id}/edit`)
      .then((contact) => {
        this.setState({ contact: { ...contact, id: params.id } })
      })
      .then(() => dispatch(setUnload()))
  }

  props: Props

  handlePhoneChange = () => {
    const errors = { ...this.state.errors, phoneNumbers: null }
    this.setState({ errors })
  }

  handleSubmit = (data, dispatch) => {
    const emails = Array.isArray(data.emails) ? data.emails : []
    const hasInvalidEmail = emails.some(({ email = '' }) => {
      const trimmed = email.trim()
      if (!trimmed) return false
      return !/^[\w.+-]+@[\w-]+(\.[\w-]+)+$/.test(trimmed)
    })
    if (hasInvalidEmail) {
      const errorMessages = { emails: 'Correct email required' }
      this.setState({ errors: errorMessages })
      throw new SubmissionError(errorMessages)
    }

    const { id } = this.state.contact
    return httpPut(`/admin/contacts/${id}`, cleaners.contact(data))
      .then((res) => {
        dispatch(setBanner('Contact successfully updated.'))
        this.props.location.navigate(-1)
      })
      .catch(({ errors }) => {
        const bannerMessage =
          'Contact was not updated. Fill out marked ' +
          'required fields that are based on their current roles.'

        const errorMessages = {}
        errors?.forEach((e) => {
          const location = e.location
          errorMessages[location] = e.message

          const isEmailLocation = typeof location === 'string' && location.toLowerCase().includes('email')

          if (location === 'email') {
            errorMessages.emails = e.message
          }
          if (location === 'emails') {
            errorMessages.email = e.message
          }
          if (isEmailLocation) {
            errorMessages.email = e.message
            errorMessages.emails = e.message
          }
        })
        dispatch(setBanner(bannerMessage, 'danger'))
        dispatch(setUnload())
        this.setState({ errors: errorMessages })
        throw new SubmissionError(errorMessages)
      })
  }

  render() {
    const { contact } = this.state
    if (!contact) return null

    const formattedEmails = (contact.emails || [])
      .map(({ email }) => ({ email }))
      .filter(({ email }) => email)

    const formattedContact = {
      ...contact,
      cellPhone: formatters.phone(contact.cellPhone),
      dayPhone: formatters.phone(contact.dayPhone),
      emails: formattedEmails.length ? formattedEmails : [{ email: contact.email || '' }],
      eveningPhone: formatters.phone(contact.eveningPhone),
      fax: formatters.phone(contact.fax),
      photoId: {
        content_type: contact.photoIdContentType,
        data: contact.photoIdData,
        key: contact.photoIdKey,
        initial: true,
      },
      ssn: formatters.ssn(contact.ssn),
    }
    return (
      <ComponentForm
        contact={contact}
        initialValues={formattedContact}
        onPhoneChange={this.handlePhoneChange}
        onSubmit={this.handleSubmit}
        errors={this.state.errors}
      />
    )
  }
}

export default withRouter(connect()(Container))